import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import initService26Hero from "../js_modules/_service-twentysix-hero.mjs";

gsap.registerPlugin(ScrollToPlugin);

initService26Hero();

const go_to_form_els = document.querySelectorAll(".go-to-form");
const faq_questions = document.querySelectorAll(".service-faq__question");

if (go_to_form_els) {
  go_to_form_els.forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      gsap.to(window, { scrollTo: { y: "#devis", offsetY: 120 }, duration: 1 });
    });
  });
}

if (faq_questions) {
  faq_questions.forEach((question) => {
    const trigger = question.querySelector(".service-faq__question-top");
    const answer_outer = question.querySelector(
      ".service-faq__question-answer-outer",
    );
    if (trigger) {
      trigger.addEventListener("click", () => {
        if (!trigger.classList.contains("open")) {
          trigger.classList.add("open");
          if (answer_outer) {
            gsap.to(answer_outer, { height: "auto", duration: 0.5 });
          }
        } else {
          trigger.classList.remove("open");
          if (answer_outer) {
            gsap.to(answer_outer, { height: 0, duration: 0.5 });
          }
        }
      });
    }
  });
}
